import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import React, { Component } from "react";
import Slider from "react-slick";
import "./style.css";

export default class PauseOnHover extends Component {
  render() {
    var settings = {
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2500,
      pauseOnHover: false,
      variableWidth: true,
      cssEase: "linear",
      speed: 2500,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            initialSlide: 3
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
      ]
    };
    return (
      <div>
        <Slider {...settings}>
          {/* flaars */}
          <div class="slide" style={{ margin: "0 3rem" }}>
            <img
              src="https://i.ibb.co/L1mcKjT/growwx.png"
              height="100"
              width="100"
              alt=""
            />
          </div>
          {/* aartzy */}
          <div class="slide" style={{ margin: "0 3rem" }}>
            <img
              src="https://i.ibb.co/MV0tsW2/aartzy-black.png"
              height="100"
              width="100"
              alt=""
            />
          </div>
          {/* spinbot */}
          <div class="slide" style={{ margin: "0 3rem" }}>
            <img
              src="https://i.ibb.co/1vcqbfH/spinbot.png"
              height="60"
              width="120"
              alt=""
            />
          </div>
          {/* luxurykase */}
          {/* <div class="slide" style={{ margin: "0 3rem" }}>
            <img
              src="https://cdn.shopify.com/s/files/1/0552/2977/5972/files/facebook_profile_image_100x.png?v=1635923131"
              height="100"
              width="100"
              alt=""
            />
          </div> */}
          {/* lakeer */}
          <div class="slide" style={{ margin: "0 3rem" }}>
            <img
              src="https://cdn.shopify.com/s/files/1/0737/0571/8077/files/lakeer_new_logo-removebg-preview_150x.png?v=1681797049"
              height="120"
              width="120"
              alt=""
            />
          </div>
          {/* ace nutrimony */}
          <div class="slide" style={{ margin: "0 3rem" }}>
            <img
              src="https://cdn.shopify.com/s/files/1/0597/4704/1479/files/Logo_New_5fb807eb-aac9-4281-ab35-0a9c906f104e_180x.png?v=1646998937"
              height="40"
              width="100"
              alt=""
            />
          </div>
          {/* market99 */}
          <div class="slide" style={{ margin: "0 3rem" }}>
            <img
              src="https://cdn.shopify.com/s/files/1/0267/1699/5754/files/logo_200x_2x_2f9616b8-00b5-4dbf-a0a9-afea286ec147_140x@2x.webp?v=1663052656"
              height="50"
              width="180"
              alt=""
            />
          </div>
          {/* flaars */}
          <div class="slide" style={{ margin: "0 3rem" }}>
            <img
              src="https://i.ibb.co/L1mcKjT/growwx.png"
              height="100"
              width="100"
              alt=""
            />
          </div>
          {/* aartzy */}
          <div class="slide" style={{ margin: "0 3rem" }}>
            <img
              src="https://i.ibb.co/MV0tsW2/aartzy-black.png"
              height="100"
              width="100"
              alt=""
            />
          </div>
          {/* spinbot */}
          <div class="slide" style={{ margin: "0 3rem" }}>
            <img
              src="https://i.ibb.co/1vcqbfH/spinbot.png"
              height="60"
              width="120"
              alt=""
            />
          </div>
          {/* luxurykase */}
          {/* <div class="slide" style={{ margin: "0 3rem" }}>
            <img
              src="https://cdn.shopify.com/s/files/1/0552/2977/5972/files/facebook_profile_image_100x.png?v=1635923131"
              height="100"
              width="100"
              alt=""
            />
          </div> */}
          {/* lakeer */}
          <div class="slide" style={{ margin: "0 3rem" }}>
            <img
              src="https://cdn.shopify.com/s/files/1/0737/0571/8077/files/lakeer_new_logo-removebg-preview_150x.png?v=1681797049"
              height="120"
              width="120"
              alt=""
            />
          </div>
          {/* ace nutrimony */}
          <div class="slide" style={{ margin: "0 3rem" }}>
            <img
              src="https://cdn.shopify.com/s/files/1/0597/4704/1479/files/Logo_New_5fb807eb-aac9-4281-ab35-0a9c906f104e_180x.png?v=1646998937"
              height="40"
              width="100"
              alt=""
            />
          </div>
          {/* market99 */}
          <div class="slide" style={{ margin: "0 3rem" }}>
            <img
              src="https://cdn.shopify.com/s/files/1/0267/1699/5754/files/logo_200x_2x_2f9616b8-00b5-4dbf-a0a9-afea286ec147_140x@2x.webp?v=1663052656"
              height="50"
              width="180"
              alt=""
            />
          </div>
        </Slider>
      </div>
    );
  }
}